module.exports = __webpack_public_path__ + "img/10-bis-logo.d0638c05.png";